import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { UmrahMyOrder } from 'shared/api/umrah/buy-tour'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList.ts'
import { dateFormat, differenceDate } from 'shared/lib/dateFormat.ts'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  order?: UmrahMyOrder
  onClick: () => void
}

export const UmrahApplicationCard = ({ order, onClick }: Props) => {
  const { t } = useTranslation()

  const dateStart = order?.start_date
  const dateEnd = order?.end_date

  const days = differenceDate({
    dateStart,
    dateEnd,
    type: 'day',
  })

  return (
    <div
      className={s.container}
      onClick={onClick}
    >
      <ImageLazy
        src={order?.logo}
        alt={'order image'}
        className={s.image}
      />

      <div className={s.info}>
        <span className={clsx('semi-bold-14', s.title)}>{order?.name}</span>
        {order?.contact_number && (
          <span className={clsx('medium-12', s.subtitle)}>
            +{order?.contact_number}
          </span>
        )}

        <div className={s.description}>
          <span className={clsx('regular-12', s.text)}>
            {t('umrah_block.dates', {
              start: dateFormat(
                dateStart,
                DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR,
              ),
              end: dateFormat(dateEnd, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR),
              count: days,
            })}
          </span>
          <span className={clsx('regular-12', s.text)}>
            {t('umrah_block.pilgrims_count', {
              count: order?.number_of_pilgrims,
            })}
          </span>
        </div>
      </div>
    </div>
  )
}
